import * as THREE from 'three';
import { el } from '../ui/dom.js';
import { icon } from '../ui/icons.js';
import { t } from '../../shared/i18n.js';

const BLUE = '#3b9eff';

// The story missions: shows the task in hand on a card, and where to go on
// the corner map and in the world. The server decides when a task is done.
export class Story {
  constructor(scene, map, net, hud, root) {
    this.map = map;
    this.hud = hud;
    this.mission = null;
    this.count = el('div.count');
    this.title = el('div.title');
    this.text = el('div.text');
    this.line = el('button.mission-line', { type: 'button', 'aria-expanded': 'false', onclick: () => this.expand() }, icon('pin', 18), el('span.mission-main', null, this.title, this.count), el('span.chev', null, icon('chevron', 16)));
    this.node = el('div.hud-card', { id: 'mission', hidden: true }, this.line, this.text);
    root.appendChild(this.node);
    this.shown = true;
    let open = false;
    try {
      open = localStorage.getItem('abakwa-mission-open') === '1';
    } catch {
      // no storage: starts folded
    }
    this.expand(open);

    const g = new THREE.CylinderGeometry(3, 3, 90, 20, 1, true);
    g.translate(0, 45, 0);
    this.beacon = new THREE.Mesh(g, new THREE.MeshBasicMaterial({ color: BLUE, transparent: true, opacity: 0.3, side: THREE.DoubleSide, depthWrite: false, fog: false }));
    this.beacon.visible = false;
    scene.add(this.beacon);

    net.on('mission', (m) => this.set(m.mission, m.done));
  }

  // Unfolds or folds the mission's text; the state is remembered.
  expand(open = this.node.classList.contains('open') ? false : true) {
    this.node.classList.toggle('open', open);
    this.line.setAttribute('aria-expanded', open ? 'true' : 'false');
    try {
      localStorage.setItem('abakwa-mission-open', open ? '1' : '0');
    } catch {
      // not remembered
    }
  }

  // mission: the task in hand. done: the task just finished, if any.
  set(mission, done) {
    if (done) this.hud.passed(done.title, done.reward, mission && !mission.finished ? mission.title : null);
    this.mission = mission;
    if (mission.finished) {
      this.count.textContent = t('All {n} missions done', { n: mission.total });
      this.title.textContent = t('The town is yours to build');
      this.text.textContent = t('Keep working, keep building, and watch the families you housed grow.');
    } else {
      const tally = mission.need ? ` · ${mission.have}/${mission.need}` : '';
      this.count.textContent = t('Mission {n} of {total} · {reward} FCFA', { n: mission.number, total: mission.total, reward: mission.reward.toLocaleString('en-US') }) + tally;
      this.title.textContent = mission.title;
      this.text.textContent = mission.text;
    }
    this.node.hidden = !this.shown;
    const target = mission.x !== undefined;
    this.beacon.visible = target;
    if (target) this.beacon.position.set(mission.x, this.map.heightmap.heightAt(mission.x, mission.z), mission.z);
  }

  // M hides or shows the card. Returns whether it is now shown.
  toggle() {
    this.shown = !this.shown;
    this.node.hidden = !this.shown || !this.mission;
    return this.shown;
  }

  // Points for the corner map: where the task wants the player to go.
  marks() {
    const m = this.mission;
    return m && m.x !== undefined ? [{ x: m.x, z: m.z, color: BLUE }] : [];
  }
}
